import { useNavigate } from 'react-router-dom';
import { useDatasourceId } from '@/hooks';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { redo, selectLatestRedoId } from '../slice';

export const useRedo = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const datasourceId = useDatasourceId();
  const latestRedoId = useAppSelector(selectLatestRedoId);

  return () => {
    if (!latestRedoId) return;

    navigate(`/datasources/${datasourceId}/queries/${latestRedoId}`);
    dispatch(redo());
  };
};
